import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { } from 'react-router-dom';
import { compose } from 'redux';
import {
  LayoutWrapperMain,
  Page,
  SubscriptionManagement,
} from '../../components';
import config from '../../config';
import './subscription.global.scss';

interface Props {
  intl: any;
  scrollingDisabled: any;
  params: any;
}

const SubscriptionManagementModule: React.FC<Props> = (props: Props) => {
  const { intl, scrollingDisabled, params } = props;
  const { siteTitle } = config;
  const schemaTitle = intl.formatMessage(
    { id: 'SupportManagement.page.title' },
    { siteTitle },
  );
  return (
    <Page
      title={schemaTitle}
      scrollingDisabled={scrollingDisabled}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        name: schemaTitle,
      }}
    >
      <LayoutWrapperMain className="layoutWrapperMain">
        <div className="content">
          <SubscriptionManagement />
        </div>
      </LayoutWrapperMain>
    </Page>
  );
};

const mapStateToProps = () => ({
});

const mapDispatchToProps = () => ({
});

const SubscriptionManagementPage = compose(

  connect(mapStateToProps, mapDispatchToProps),
  injectIntl,
)(SubscriptionManagementModule);

export default SubscriptionManagementPage;
